import React, { Component } from 'react';
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import { ToastContainer, toast } from "react-toastify";
import $ from "jquery";
import Loader from 'react-loader-spinner';

class PaymentGateWaySetting extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      data: [{
        id: '',
        paymentSettingName: '',
        paymentSettingValue: '',
      }],
      editedpaymentSettingName: '-1',
      editImageSrc: './assets/images/edit2.png',
      contentEditable: "false",
      editId: '-1',
      successResp: false,
      hideResetPopup: false,
      paymentSettingName: ''
    }
    this.editImageSrc = "./assets/images/edit2.png";
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.dialogClose = () => {
      this.setState({
        hideResetPopup: false,
      });
    };

    this.settings = { effect: 'Zoom', duration: 600, delay: 0 };

    //for reset dialog component ok click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': (props) => {
        this.resetAdvancedCustomProperty(this.state.propsId)
      }
    },
    {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({ hideResetPopup: false });
      }
    }];
  }


  notifyEmptyFields() {
    toast.dismiss();
    this.state.editId = '0';
    toast(<b> <img src="assets/images/warn.svg"
        style={{ paddingRight: '0px', height: '20px', width: '20px' }}
        content="" /> &nbsp;&nbsp; Please fill value field</b >, {
        position: "top-center"
    });
  }

  fetchPropertiesApi(projectId) {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var propertyController = this;
    $.ajax({
      url: "/api/payment-properties",
      async: false,
      method: 'GET',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      data: {
        "projectId": projectId,
        "paymentGateway": "RAZORPAY"
      },
      success: function (res) {
        if (res.success === true) {
          propertyController.setState({
            data: res.result,
            successResp: true,
            editId: '-1'
          });


        } else {
          propertyController.setState({
            successResp: false
          });
          propertyController.notifyFailToCreate(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  saveProjectPaymentGateWayApi() {
    var propertyController = this;
    var data = {
      "projectId": localStorage.getItem("currentProjectId"),
      "paymentGateway": "RAZORPAY"
    }
    $.ajax({
      url: "/api/project-paymentGateway",
      async: false,
      method: 'POST',
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token"),
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(data),
      success: function (res) {
        if (res.success === true) {


        } else {
          propertyController.setState({
            successResp: false
          });
          propertyController.notifyFailToCreate(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  refreshPropertyData = () => {
    this.fetchPropertiesApi();
  }

  markAsBeingEdited(paymentSettingName) {
    this.state.editedpaymentSettingName = paymentSettingName;
    var stateObj = this.state;
    this.setState(stateObj);
    this.state.editId = '0';

  }

  validateCells(paymentSettingValue) {

    if (paymentSettingValue != "") {
      return true;
    } else {

      this.notifyEmptyFields();
      return false;
    }
  }
  notifyFailToCreate(falseResult) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{falseResult}</b>, {
      position: "top-center",
      color: "red"

    });
  }
  notifyProperyUpdatedSuccess(paymentSettingName) {
    toast.dismiss();
    paymentSettingName = paymentSettingName.split("_").join(" ");;
    toast(<b style={{ color: "#A9A9A9" }}><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;{paymentSettingName} property updated Successfully</b>, {
      position: "top-center",
    });

  }

  notifyResetSuccess(paymentSettingName) {
    toast.dismiss();
    paymentSettingName = paymentSettingName.split("_").join(" ");;
    toast(<b style={{ color: "#A9A9A9" }}><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;{paymentSettingName} property has been reset successfully</b>, {
      position: "top-center",
    });

  }

  savePaymentGateWaySettingsApi(props, e) {
    var advancedCustomController = this;
    props.original.paymentSettingName = document.getElementById("paymentSettingName" + props.index).innerText.trim();
    props.original.paymentSettingValue = document.getElementById("paymentSettingValue" + props.index).innerText.trim();
    this.setState(this.state);
    var validateResult = this.validateCells(props.original.paymentSettingValue);
    if (validateResult == true) {
      var updatedData = {
        id: props.original.id,
        projectId: localStorage.getItem("currentProjectId"),
        paymentGateway: 'RAZORPAY',
        paymentSettingName: props.original.paymentSettingName,
        paymentSettingValue: props.original.paymentSettingValue
      };

      $.ajax({
        url: "/api/paymentProperties-update",
        async: false,
        method: 'PATCH',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(updatedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            advancedCustomController.notifyProperyUpdatedSuccess(updatedData.paymentSettingName);
            advancedCustomController.setState({ editedpaymentSettingName: '-1' });
            advancedCustomController.saveProjectPaymentGateWayApi()
            advancedCustomController.fetchPropertiesApi();
          } else {
            advancedCustomController.notifyFailToCreate(res.result);


          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/";
          }
        }

      })
    }

  }

  editCell(props, e) {
    this.markAsBeingEdited(props.original.paymentSettingName);
  }

  componentDidMount() {
    var thisController = this;
    setTimeout(() => {
      thisController.saveProjectPaymentGateWayApi()
      thisController.fetchPropertiesApi();
    }, 300);
    document.addEventListener("projectChanged", function (event) {
      thisController.projectId = event.projectId;
      thisController.fetchPropertiesApi(event.projectId);

    });
  }
  render() {
    const { data } = this.state
    this.columns = [
      {
        Header: <b >Id</b>,
        accessor: 'id',
        minWidth: 5,
        show: false,
        sortable: false,
        Cell: props => (<div
          Align="left"
          type="text" id={"paymentId" + props.index}

        >{props.original.id}</div>
        )
      },
      {
        Header: <b >Name</b>,
        accessor: 'paymentSettingName',
        minWidth: 20,
        sortable: false,
        Cell: props => (<div
          Align="left"
          type="text" id={"paymentSettingName" + props.index}

        >{props.original.paymentSettingName}</div>
        )
      },
      {
        Header: <b>Value</b>,
        accessor: 'paymentSettingValue',
        minWidth: 22,
        sortable: false,
        Cell: props => (<div
          Align="left" className="input"
          style={{ padding: "8px", borderBottom: 'none', border: (props.original.paymentSettingName == this.state.editedpaymentSettingName && this.state.editId == '0') ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.paymentSettingName == this.state.editedpaymentSettingName && this.state.editId == '0') ? '2px' : 'none', paddingLeft: '2px' }}
          contentEditable={(props.original.paymentSettingName == this.state.editedpaymentSettingName) && this.state.editId === '0'}
          suppressContentEditableWarning
          type="text" id={"paymentSettingValue" + props.index} name="paymentSettingValue"
        >{props.original.paymentSettingValue}</div>)
      },
      {
        Header: <b>Actions</b>,
        minWidth: 8,
        Cell: props => (
          <div Align="left">

            {/* Edit/Save Button */}
            <button title={(props.original.paymentSettingName == this.state.editedpaymentSettingName && this.state.editId == '0') ? "save" : "edit"} style={{ backgroundColor: "#ffffff", border: "none" }}><img className="img-responsive" id="editORsave" style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }} src={(props.original.paymentSettingName == this.state.editedpaymentSettingName && this.state.editId == '0') ? this.saveImageSrc : this.editImageSrc}
              onClick={(e) => {
                (props.original.paymentSettingName == this.state.editedpaymentSettingName) ? this.savePaymentGateWaySettingsApi(props, e)
                  :
                  this.editCell(props, e);

              }}
            />
            </button>

          </div>

        )
      }
    ]
    return (
      <div  >
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={this.state.successResp ? false : true}
          height={300}
          width={50}
          style={{ textAlign: 'center' }}
        />
        {/* for reactToast */}
        <link rel="stylesheet" href="assets/css/ReactToastify.css" />

        {/* for reactTable */}
        <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
        <div className="wrapper" style={{ display: this.state.successResp ? 'block' : 'none' }}>
          <div className="container-fluid" style={{ marginTop: "0px" }}>
            < ToastContainer className="Toast-at-center" />
            <div className="row">
              <div className="col-sm-5">
                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '20px' }}>Payment Gateway Settings</h6>


                <br />
              </div>
              <div className="col-sm-7" Align="right">
                <button className="btn action-button"
                  title="Refresh" onClick={this.refreshPropertyData}>
                  <img src="./assets/images/refresh_white_24dp.png" />
                </button>
              </div>
              <div className="col-lg-12 ">

                <div className="card">

                  <div >
                    <ReactTable id='reactTable'
                      data={data}
                      columns={this.columns}
                      defaultPageSize={10}
                      pageSizeOptions={[5, 10, 15]}

                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default PaymentGateWaySetting;


// WEBPACK FOOTER //
// ./src/projectmgmt/settings/PaymentGateWaySetting.js